import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #FFFFFF;
    font-family: Mulish;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 18px;
    border-bottom: 1px solid #EEF1F6;
    flex: 0 0 auto;
`;

export const HeaderAvatar = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${(props) => props.$color || "#2BC0AD"};
    color: #FFFFFF;
    font-weight: 700;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    overflow: hidden;
    img { width: 100%; height: 100%; object-fit: cover; }
`;

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const HeaderName = styled.span`
    font-weight: 800;
    color: #2B3240;
    font-size: 0.95rem;
`;

export const HeaderMembers = styled.span`
    display: flex;
    align-items: center;
    gap: 5px;
    color: #9AA4B2;
    font-size: 0.74rem;
    svg { font-size: 0.85rem; }
`;

export const Body = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 12px 18px;
    background: #FBFCFE;

    ::-webkit-scrollbar { width: 8px; }
    ::-webkit-scrollbar-thumb { background-color: #BABABA; border-radius: 5px; }
`;

export const State = styled.div`
    padding: 28px 12px;
    text-align: center;
    color: #8A94A6;
    font-size: 0.85rem;
`;
